import { AppDispatch } from '@/root/store';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { SectionItem, SectionTabs } from '../../../_nav/section';

const sections: Record<string, string> = {
  voucher: 'Daftar voucher',
  affiliator: 'Daftar affiliator',
  announcement: 'Daftar pengumuman',
  'social-media': 'Daftar sosial media',
};

export function OrgEventMarketingLayout() {
  const location = useLocation();
  const dispatch: AppDispatch = useDispatch();

  const pathArray = location.pathname.split('/').slice(2);
  const section = pathArray[2];

  const { event } = useSelector((state: any) => state.event);

  return !section ? (
    <Navigate to='voucher' />
  ) : (
    <>
      <SectionTabs grow={false}>
        {Object.entries(sections).map(([key, value]) => {
          return (
            <SectionItem
              id={key}
              key={key}
              name={value}
              isCurrent={section === key}
            />
          );
        })}
      </SectionTabs>
      <Outlet />
    </>
  );
}
